"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="11571" id="hero-overview" className="bg-background text-foreground py-32 md:py-44 px-5 md:px-8 overflow-hidden">
      <div className="max-w-[1280px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {}
          <div ref={leftRef} className="lg:col-span-7 transition-all duration-700 ease-out" style={{
          opacity: leftVisible ? 1 : 0,
          transform: leftVisible ? "translateY(0)" : "translateY(16px)"
        }}>
            <div className="font-default text-xs font-medium uppercase mb-8" style={{
            letterSpacing: "0.14em",
            color: "var(--primary)"
          }}>
              Fire Protection Engineering
            </div>

            <h1 className="font-default font-bold text-foreground" style={{
            fontSize: "clamp(2.75rem, 5.5vw, 5rem)",
            letterSpacing: "-0.02em",
            lineHeight: 1.04
          }}>
              Precision, clarity, and the{" "}
              <em className="font-default not-italic" style={{
              fontStyle: "italic",
              color: "var(--primary)",
              fontWeight: 400
            }}>
                foresight
              </em>{" "}
              to grow.
            </h1>

            <p className="font-default mt-8 text-foreground/75 max-w-[52ch]" style={{
            fontSize: "clamp(1.0625rem, 1.2vw, 1.25rem)",
            letterSpacing: "-0.005em",
            lineHeight: 1.55,
            fontWeight: 400
          }}>
              We provide specialized fire protection engineering and risk management for hazardous industries—optimizing risk mitigation through rigorous analysis and technical expertise to ensure long-term operational resilience.
            </p>

            <div className="mt-10 flex flex-col sm:flex-row gap-4">
              <Button asChild size="lg" className="h-12 px-7 rounded-lg font-medium bg-primary text-primary-foreground hover:bg-primary/90 shadow-md transition-all duration-200 hover:-translate-y-px">
                <Link to="/ContactPage">Schedule Consultation</Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="h-12 px-7 rounded-lg font-medium bg-transparent border border-foreground/80 text-foreground hover:bg-foreground/10 hover:text-foreground transition-all duration-200">
                <Link to="/ServicesPage">View Our Services</Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={rightRef} className="lg:col-span-5 transition-all duration-700 ease-out" style={{
          opacity: rightVisible ? 1 : 0,
          transform: rightVisible ? "translateY(0)" : "translateY(16px)",
          transitionDelay: "120ms"
        }}>
            <div className="relative w-full overflow-hidden rounded-lg shadow-lg" style={{
            aspectRatio: "16 / 10",
            border: "1px solid var(--border)",
            padding: "8px",
            backgroundColor: "var(--card)"
          }}>
              <div className="relative w-full h-full overflow-hidden rounded-md">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705042/img/fire_protection_engineering.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705042/img/fire_protection_engineering.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705042/img/fire_protection_engineering.png-wvc-sizes" alt="Fire protection engineering workspace" loading="lazy" decoding="async" className="w-full h-full object-cover" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}